import { Link, PreApp } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { AppRoute } from '~src/main/routes';

interface Props {
  error: Error;
}

export function AppAuthError({ error }: Props) {
  const { t } = useTranslation();

  console.error(error);

  return (
    <PreApp.Wrapper>
      <PreApp.Stack>
        <PreApp.Title>{t('errors.title')}</PreApp.Title>
        <PreApp.Subtitle>{t('auth.errorSubtitle')}</PreApp.Subtitle>
      </PreApp.Stack>

      <Link href={AppRoute.LOGIN} underline>
        {t('auth.signIn')}
      </Link>
    </PreApp.Wrapper>
  );
}
